<app-work-operational-work
    class="pt-2 subpage-content"
    [inDialog]="true"
    (closeCallback)="dialogRef.close()"
></app-work-operational-work>

<div #dialogFooter></div>
